<template>
    <div class="competition-record">
        <div class="search-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item label="赛事名称">
                    <el-input v-model="queryParams.matchName" placeholder="请输入赛事名称" size="small" />
                </el-form-item>
                <el-form-item label="报名状态">
                    <el-select v-model="queryParams.signUpStatus" placeholder="请选择报名状态" style="width: 200px"
                        size="small">
                        <el-option v-for="item in statusOptions" :key="item.value"
                            :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clickQueryBtn" size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="table-container">
            <el-table :data="tb.data" v-loading="loading" style="width: 100%" size="mini" border>
                <el-table-column prop="MatchName" label="赛事名称" />
                <el-table-column label="分组" prop="GroupName" align="center">
                    <template v-slot="scope">
                        {{ scope.row.GroupName }}({{ scope.row.IsSuper == 1 ? '超级组' : '普通组' }})
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="报名时间" align="center">
                    <template #default="scope">
                        {{ formatDate(scope.row.CreateTime) }}
                    </template>
                </el-table-column>
                <el-table-column prop="AthleteCount" label="运动员人数" align="center" />
                <el-table-column prop="TeamLeaderCount" label="随队人员人数" align="center" />
                <el-table-column prop="TeamLeaderCount" label="回执" align="center">
                    <template v-slot="scope">
                        <el-button type="text" @click="showUploadReceiptDialog(scope.row)">上传/查看({{
                            scope.row.ReceiptFileIds == '' ? 0 :
                                scope.row.ReceiptFileIds.split(',').length }})</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="报名状态" align="center">
                    <template #default="scope">
                        <el-tag size="small" :type="getStatusType(scope.row.SignUpStatus)">
                            {{ getStatusText(scope.row.SignUpStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="AuditResult" label="审核结果" align="center" />
                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <el-button type="text" @click="clickEditBth(scope.row)" v-if="scope.row.SignUpStatus != 1">修改</el-button>
                        <el-button type="text" @click="viewDetails(scope.row)">详情/打印</el-button>
                        <el-button type="text" v-if="scope.row.SignUpStatus == 1"
                            @click="viewScores(scope.row)">成绩详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="tb.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="tb.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="tb.total" />
            </div>
        </div>

        <el-dialog :visible.sync="showFormVisible" top="30px" width="1000px">
            <div style="margin: 0 auto;">
                <MatchSignResult :signData="signFormDetail" v-if="signFormDetail"></MatchSignResult>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showFormVisible = false">取 消</el-button>
                <!-- <el-button type="primary" @click="printForm">打 印</el-button> -->
            </span>
        </el-dialog>
        <el-dialog title="回执上传" :visible.sync="uploadReceiptDialogVisible" width="1000px">
            <div class="teamPhoto" style="padding-top: 20px;box-sizing: border-box;text-align: center;">
                <el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview"
                    :http-request="(file) => uploadFile(file, 'receiptPhoto')" :file-list="fileList"
                    :on-remove="handleRemove" :on-exceed="handleExceed" accept=".jpg,.png,.jpeg" :limit="5" multiple>
                    <i class="el-icon-plus"></i>
                </el-upload>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="setMatchSignUpFormReceiptFileIds" :loading="submitLoading">提
                    交</el-button>
                <el-button type="info" @click="uploadReceiptDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imageDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="比赛成绩" :visible.sync="showScoreVisible" width="1000px">
            <el-table :data="score" border>
                <el-table-column label="分组" prop="GroupName" align="center"></el-table-column>
                <el-table-column label="项目名" prop="ProjectName" align="center" width="200"></el-table-column>
                <el-table-column label="项目类型" align="center">
                    <template v-slot="scope">
                        {{ scope.row.IsSuper == 1 ? '超级组' : '普通组' }}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="UserName" align="center"></el-table-column>
                <el-table-column label="状态" prop="Status" align="center">
                    <template v-slot="scope">
                        <span v-if="scope.row.Status == 0">待上场</span>
                        <span v-if="scope.row.Status == 1">准备区</span>
                        <span v-if="scope.row.Status == 2">比赛中</span>
                        <span v-if="scope.row.Status == 3">已比赛</span>
                        <span v-if="scope.row.Status == 4">弃权</span>
                    </template>
                </el-table-column>
                <el-table-column label="成绩" prop="Score" align="center"></el-table-column>
                <el-table-column label="得分" prop="TotalPoints" align="center"></el-table-column>
                <el-table-column label="名次" prop="Ranking" align="center"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showScoreVisible = false" size="small">取 消</el-button>
                <!-- <el-button type="primary" @click="printForm">打 印</el-button> -->
            </span>
        </el-dialog>




        <!-- 选择运动员和随队人员的对话框 -->
        <el-dialog title="选择参赛人员" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false"
            v-if="dialogVisible">
            <el-steps :active="sipnUpStep" finish-status="success" process-status="finish" size="mini" align-center>
                <el-step title="选择参赛项目"></el-step>
                <el-step title="随队人员登记"></el-step>
                <el-step title="上传集体照(上限5张)"></el-step>
                <el-step title="确认信息"></el-step>
            </el-steps>

            <div style="margin: 20px 20px;min-height: 400px;" v-show="sipnUpStep == 0">

                <el-tabs v-model="signUpTabsActiveName" type="card">
                    <el-tab-pane v-for="(group, index) in signUpMatchGroups" :label="group.GroupName"
                        :name="group.GroupId">
                        <div class="limit-info" style="margin-bottom: 15px; color: red;">
                            <p>限报年级：{{ group.GradeCondition ? group.GradeCondition : '不限' }}</p>
                            <p>限报年龄：
                                <span v-if="!group.BirthdayStartTime && !group.BirthdayEndTime">不限</span>
                                <span v-if="group.BirthdayStartTime && group.BirthdayEndTime">
                                    {{ group.BirthdayStartTime.split(' ')[0] }}至{{ group.BirthdayEndTime.split(' ')[0]
                                    }}出生
                                </span>
                                <span v-if="group.BirthdayStartTime && !group.BirthdayEndTime">
                                    {{ group.BirthdayStartTime.split(' ')[0] }}后出生
                                </span>
                                <span v-if="!group.BirthdayStartTime && group.BirthdayEndTime">
                                    {{ group.BirthdayEndTime.split(' ')[0] }}前出生
                                </span>
                                <span style="margin:0 10px;"
                                    v-if="group.MustHaveCertificate == 1">且运动员信息必须维护证件(团队管理-运动员管理中维护)</span>
                            </p>
                            <p>
                                队伍组成：领队{{ group.TeamLeaderMaxNum > 0 ?
                                    group.TeamLeaderMaxNum + '人' : '不限' }}，
                                教练{{ group.CoachMaxNum > 0 ?
                                    group.CoachMaxNum + '人' : '不限' }}，
                                医护人员{{ group.MedicalMaxNum > 0 ?
                                    group.MedicalMaxNum + '人' : '不限' }}，
                                合计运动员{{ group.AthleteMaxNum > 0 ?
                                    group.AthleteMaxNum + '人' : '不限' }}，
                                男运动员{{ group.BoyAthleteMaxNum > 0 ?
                                    group.BoyAthleteMaxNum + '人' : '不限' }}，
                                女运动员{{ group.GirlAthleteMaxNum > 0 ?
                                    group.GirlAthleteMaxNum + '人' : '不限' }}
                            </p>

                            <p>运动员限制：每人限报个人项目数{{
                                group.EveryBodyRestrictReportPersonalProjectMaxNum > 0
                                    ?
                                    group.EveryBodyRestrictReportPersonalProjectMaxNum
                                    + '个'
                                    : '不限' }}，
                                每人限报团队项目数{{
                                    group.EveryBodyRestrictReportTeamProjectMaxNum > 0
                                        ?
                                        group.EveryBodyRestrictReportTeamProjectMaxNum
                                        + '个' :
                                        '不限' }}</p>
                        </div>
                        <div class="match-project-list" style="margin-top: 10px;">
                            <el-table ref="multipleTable" :data="group.Projects" style="width: 100%" border size="small"
                                @selection-change="(val) => handleProSelectionChange(val, index)">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="ProjectName" label="项目名称" width="180" align="center">
                                    <template v-slot="scope">
                                        <el-tag size="mini" type="danger" v-if="scope.row.IsMustSignUp == 1">必报</el-tag>
                                        {{ scope.row.ProjectName }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="ProjectTypeName" label="项目类型" width="120" align="center">
                                </el-table-column>
                                <el-table-column prop="GenderRuleText" label="性别" width="120" align="center">
                                </el-table-column>
                                <el-table-column label="报名类型" width="80" align="center">
                                    <template v-slot="scope">
                                        <span v-if="scope.row.SignUpLimitType == 0">团队</span>
                                        <span v-if="scope.row.SignUpLimitType == 1">个人</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="SignUpLimitNumText" label="项目人数" width="120"
                                    align="center"></el-table-column>
                                <el-table-column label="参赛运动员">
                                    <template v-slot="scope">
                                        <div style="position: relative;width: 100%;overflow: auto;">
                                            <span v-if="scope.row.athletes && scope.row.athletes.length > 0">
                                                <el-tag v-for="(item, i) in scope.row.athletes" :key="i" closable
                                                    @close="removeAthlete(index, scope.$index, i)" style="margin: 2px">
                                                    {{ item.userNames }}
                                                </el-tag>
                                            </span>
                                            <el-button size="mini" icon="el-icon-plus" circle
                                                v-if="signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId) &&
                                                    (!scope.row.athletes || scope.row.athletes.length < scope.row.SignUpLimitNum)"
                                                @click="openAthleteDialog(scope.row, index)">
                                            </el-button>
                                        </div>

                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="上传音乐" width="100" align="center">
                                    <template v-slot="scope">
                                        <el-upload class="upload-demo" action="#"
                                            :http-request="(file) => uploadFile(file, index + '-' + scope.$index)"
                                            :multiple="false" :show-file-list="false" accept=".mp3"
                                            v-if="(scope.row.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' ||
                                                scope.row.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')
                                                && signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId)">
                                            <el-button v-if="!scope.row.File || scope.row.File.FileId == ''" size="mini"
                                                type="primary">上传音乐</el-button>

                                            <el-tooltip v-if="scope.row.File && scope.row.File.FileId != ''"
                                                :content="scope.row.File.FileName + scope.row.File.FileSuffix"
                                                effect="light">
                                                <el-button size="mini" type="success">已上传</el-button>
                                            </el-tooltip>
                                        </el-upload>

                                        <span
                                            v-if="(scope.row.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826' ||
                                                scope.row.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917')
                                                && signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId)">无需上传</span>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </div>
            <div style=" margin: 20px 20px;min-height: 400px;" v-show="sipnUpStep == 1">
                <el-table ref="multipleTable2" :data="unitStaffList" 
                :row-key="getRowKey"
                style="width: 100%" border size="small"
                    max-height="300px" @selection-change="handleStaffTableSelectionChange">
                    <el-table-column type="selection" width="55" align="center">
                    </el-table-column>
                    <el-table-column prop="StaffName" label="姓名" width="150" align="center"></el-table-column>
                    <el-table-column prop="Gender" label="性别" width="100" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.Gender == 0">男子</span>
                            <span v-else>女子</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Age" label="年龄" width="100" align="center"></el-table-column>
                    <!-- <el-table-column prop="IdCardType" label="证件类型" width="120"></el-table-column> -->
                    <el-table-column prop="IdentityCard" label="身份证号码" width="150" align="center"></el-table-column>
                    <el-table-column prop="Birthday" label="出生日期" width="120" align="center">
                        <template v-slot="scope">
                            {{ formatBirthday(scope.row.Birthday) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="StaffPhone" label="手机号码" width="150" align="center"></el-table-column>
                    <el-table-column prop="Post" label="身份" width="120" align="center"></el-table-column>
                    <el-table-column prop="Remarks" label="备注" align="center"></el-table-column>
                </el-table>
            </div>
            <div style="margin: 20px 20px; text-align: center;min-height: 400px;" v-show="sipnUpStep == 2">
                <div class="teamPhoto" style="padding-top: 50px;box-sizing: border-box;">
                    <el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :http-request="(file) => uploadFile(file, 'teamPhoto')" :file-list="fileList"
                        :on-remove="handleRemove" :on-exceed="handleExceed" accept=".jpg,.png,.jpeg" :limit="5"
                        multiple>
                        <i class="el-icon-plus"></i>
                    </el-upload>

                </div>
            </div>
            <div style="margin: 20px 20px; text-align: center;min-height: 400px;" v-show="sipnUpStep == 3">
                <!-- 报名表确认视图 -->
                <div class="sign-up-confirmation">
                    <!-- 基本信息部分 -->
                    <div class="basic-info">
                        <table class="info-table" v-if="matchInfo">
                            <tr>
                                <td class="label">赛事名称：</td>
                                <td colspan="3">{{ matchInfo.MatchName }}</td>
                            </tr>
                            <tr>
                                <td class="label">赛事时间：</td>
                                <td colspan="3">{{ formatDateTime(matchInfo.StartTime) }} ~ {{
                                    formatDateTime(matchInfo.EndTime) }}</td>
                            </tr>
                            <tr>
                                <td class="label">参赛单位：</td>
                                <td colspan="3">{{ unitInfo.UnitName }}</td>
                            </tr>
                            <tr>
                                <td class="label">单位联系人：</td>
                                <td>{{ unitInfo.UnitManagerName }}</td>
                                <td class="label">联系电话：</td>
                                <td>{{ unitInfo.UnitManagerPhone }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- 参赛项目列表 -->
                    <div class="projects-list">
                        <h4>参赛项目</h4>
                        <el-table :data="getFlattenedProjectsList()" border size="small"
                            :span-method="handleProjectSpanMethod">
                            <el-table-column prop="groupName" label="组别" align="center"></el-table-column>
                            <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
                            <el-table-column prop="projectTypeName" label="项目类型" align="center"></el-table-column>
                            <el-table-column prop="genderRuleText" label="性别" align="center"></el-table-column>
                            <el-table-column prop="athleteName" label="参赛运动员" align="center"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 参赛运动员详细信息列表 -->
                    <div class="athletes-detail-list" v-if="getAllAthletes().length > 0">
                        <h4>参赛运动员信息</h4>
                        <el-table :data="getAllAthletes()" border size="small">
                            <el-table-column prop="athleteName" label="姓名" align="center"></el-table-column>
                            <el-table-column prop="identityCard" label="身份证" align="center"></el-table-column>
                            <el-table-column prop="age" label="年龄" align="center"></el-table-column>
                            <el-table-column prop="gender" label="性别" align="center">
                                <template #default="scope">
                                    <span>{{ scope.row.gender === 0 ? '男子' : '女子' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
                            <el-table-column prop="grade" label="年级" align="center"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 随队人员列表 -->
                    <div class="staff-list" v-if="staffTableSelection.length > 0">
                        <h4>随队人员</h4>
                        <el-table :data="staffTableSelection" border size="small">
                            <el-table-column prop="StaffName" label="姓名" align="center"></el-table-column>
                            <el-table-column prop="IdentityCard" label="身份证" align="center"></el-table-column>
                            <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
                            <el-table-column prop="Gender" label="性别" align="center">
                                <template #default="scope">
                                    <span>{{ scope.row.Gender === 0 ? '男子' : '女子' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="StaffPhone" label="联系电话" align="center"></el-table-column>
                            <el-table-column prop="Post" label="身份" align="center"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <template #footer>
                <el-button @click="dialogVisible = false" type="info" size="small">取消</el-button>
                <el-button type="primary" @click="backStep" size="small" v-if="sipnUpStep > 0">上一步</el-button>
                <el-button type="primary" @click="handleNextStep" size="small" v-if="sipnUpStep < 3">下一步</el-button>
                <el-button @click="confirmSignUp('存草稿')" size="small">存草稿</el-button>
                <el-button type="primary" @click="confirmSignUp('提交')" size="small" v-if="sipnUpStep == 3">提交报名</el-button>
            </template>
        </el-dialog>
        <el-dialog :visible.sync="imageDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- 在 template 中添加运动员选择对话框 -->
        <el-dialog title="选择运动员" :visible.sync="athleteDialogVisible" width="800px" :close-on-click-modal="false">
            <div v-if="currentProject">
                <div class="limit-info" style="margin-bottom: 15px; color: #E6A23C;">
                    <el-alert :title="currentProject.SignUpLimitType === 0 ?
                        `该项目最多可选择 ${currentProject.SignUpLimitNum} 个团队` :
                        `该项目最多可选择 ${currentProject.SignUpLimitNum} 名运动员`" type="warning" :closable="false" show-icon>
                    </el-alert>
                </div>

                <div v-if="currentProject.SignUpLimitType === 0" class="team-select">
                    <!-- 已选择的团队列表 -->
                    <div class="selected-teams" v-if="selectedTeams.length > 0">
                        <h4>已选择的团队 ({{ selectedTeams.length }}/{{ currentProject.SignUpLimitNum }})：</h4>
                        <div class="team-list">
                            <!-- <el-tag v-for="(team, index) in selectedTeams" :key="index" closable
                                @close="removeTeam(index)" style="margin: 5px">
                                {{ team.userNames }}
                            </el-tag> -->
                            <el-table :data="selectedTeams" style="width: 100%" size="mini" border>
                                <el-table-column label="运动员" prop="userNames">
                                </el-table-column>
                                <el-table-column label="操作" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" style="color: red;" size="mini"
                                            @click="removeTeam(scope.$index)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>

                    <!-- 选择运动员组建团队 -->
                    <div class="create-team">
                        <h4>组建新团队</h4>
                        <el-select size="small" v-model="tempSelectedAthletes" multiple placeholder="请选择运动员组建团队"
                            style="margin-bottom: 10px;width: 80%;">
                            <el-option
                                v-for="athlete in unitAthleteList.filter(a => (signUpMatchGroups[0].GradeCondition == '' || signUpMatchGroups[0].GradeConditionArr.indexOf(a.Grade) > -1) && (currentProject.GenderRule == 2 || currentProject.GenderRule == a.Gender))"
                                :key="athlete.AthleteId"
                                :label="athlete.UserName + '(' + (athlete.Gender == 0 ? '男' : '女') + ')'"
                                :value="athlete.AthleteId">
                                <span style="float: left">{{ athlete.UserName }}
                                    <el-tag :type="athlete.Gender == 0 ? '' : 'danger'" style="margin: 0 5px;"
                                        size="mini">{{
                                            (athlete.Gender == 0 ? '男' : '女')
                                        }}</el-tag>
                                    <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Grade }}</el-tag>
                                </span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ athlete.GroupId }}</span>
                            </el-option>
                        </el-select>
                        <el-button size="small" type="primary" @click="createTeam"
                            :disabled="!tempSelectedAthletes.length">
                            确认组建团队
                        </el-button>
                    </div>

                    <el-divider>或</el-divider>

                    <!-- 选择已有团队 -->
                    <div class="select-team">
                        <h4>选择已有团队</h4>
                        <el-table :data="unitTeamList" style="width: 100%" border size="mini" class="compact-table">
                            <el-table-column prop="TeamName" label="团队名称"></el-table-column>
                            <el-table-column prop="AthleteNames" label="团队成员"></el-table-column>
                            <el-table-column prop="Remarks" label="团队备注"></el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template v-slot="scope">
                                    <el-button type="text" size="mini" @click="addExistingTeam(scope.row)">
                                        添加
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else>
                    <!-- 个人模式 -->
                    <h4>已选择运动员 ({{ selectedAthleteIds.length }}/{{ currentProject.SignUpLimitNum }})：</h4>
                    <el-select v-model="selectedAthleteIds" multiple placeholder="请选择运动员" style="width: 100%">
                        <el-option
                            v-for="athlete in unitAthleteList.filter(a => (signUpMatchGroups[0].GradeCondition == '' || signUpMatchGroups[0].GradeConditionArr.indexOf(a.Grade) > -1) && (currentProject.GenderRule == 2 || currentProject.GenderRule == a.Gender))"
                            :key="athlete.AthleteId"
                            :label="athlete.UserName + '(' + (athlete.Gender == 0 ? '男' : '女') + ') '"
                            :value="athlete.AthleteId">
                            <span style="float: left">{{ athlete.UserName }}
                                <el-tag :type="athlete.Gender == 0 ? '' : 'danger'" style="margin: 0 5px;"
                                    size="mini">{{
                                        (athlete.Gender == 0 ? '男' : '女')
                                    }}</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Grade }}</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Age }}岁</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Birthday.split(' ')[0] }}</el-tag>
                            </span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ athlete.GroupId }}</span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" v-if="selectedAthleteIds.length > 0 || selectedTeams.length > 0"
                    @click="confirmAthleteSelection" size="small">确定</el-button>
                <el-button @click="athleteDialogVisible = false" type="info" size="small">取消</el-button>
            </template>
        </el-dialog>
        <el-dialog title="报名信息" :visible.sync="signUpResultDialogVisible" top="30px" width="900px"
            :close-on-click-modal="false">
            <MatchSignResult :signData="signUpRecord" ref="signResultComponent" />
            <template #footer>
                <!-- <el-button type="primary" @click="printSignUpForm" size="small">打印</el-button> -->
                <el-button @click="hideSignUpFormDialog" size="small">关闭</el-button>
            </template>
        </el-dialog>

    </div>
</template>

<script>
import contestantServices from '../../../request-server/request-services/contestant-services';
import systemService from '@/request-server/request-services/system-services.js';
import utilsCommon from '@/utils/utils-common';
import MatchSignResult from '@/components/common/match-sign-result.vue';
import { mapState } from 'vuex';
import Url from '@/request-server/request-url';
export default {
    name: 'CompetitionRecord',
    components: {
        MatchSignResult
    },
    data() {
        return {
            fileRootPath: '',
            loading: false,
            showFormVisible: false,
            showScoreVisible: false,
            signFormDetail: null,
            print: false,
            score: [],
            // 查询参数
            queryParams: {
                matchName: '',
                signUpStatus: '',

            },
            tb: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
                data: null
            },
            // 状态选项
            statusOptions: [
                { value: -1, label: '全部' },
                { value: 0, label: '审核中' },
                { value: 1, label: '已通过' },
                { value: 2, label: '未通过' },
                { value: 3, label: '已撤回' },
                { value: 4, label: '覆盖、失效' },
                { value: 5, label: '草稿' }
            ],
            uploadReceiptDialogVisible: false,
            uploadReceiptFormId: '',
            uploadReceiptFileIds: [],
            imageDialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            submitLoading: false,


            matchInfo: null,
            selectedProjects: [],
            dialogVisible: false,
            athletesList: [],
            staffList: [],
            selectedAthletes: [],
            selectedStaff: [],
            groupRadioValue: '',
            matchProjects: [],
            sipnUpStep: 0,
            signUpTabsActiveName: '',
            signUpMatchGroups: [],
            unitStaffList: [],
            unitAthleteList: [],
            staffTableSelection: [],
            teamPhotoFiles: [],
            athleteDialogVisible: false,
            currentProject: null,
            athleteActiveTab: 'athletes',
            selectedTeams: [],
            selectedAthleteIds: [],
            unitTeamList: [],
            currentGroupIndex: null,
            currentProjectIndex: null,
            tempSelectedAthletes: [], // 临时存储正在组建的团队成员
            signUpRecord: null,
            signUpResultDialogVisible: false,
            tabsValue: '赛事项目',
            matchScores: null,
            signUpGroupIds: [],
            signUpFormId: '',
            signData: null,
            firstLoadSignUpForm: true,
        };
    },
    computed: {
        ...mapState({
            unitInfo: state => state.unitInfo
        })
    },
    // mounted() {
    //     // 获取路由参数中的name
    //     let name = this.$route.params.name;
    //     if (name) this.queryParams.matchName = name;
    //     this.fetchRecords();
    // },
    created() {
        let name = this.$route.params.name;
        if (name) this.queryParams.matchName = name;

        this.fetchRecords();
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/';
        this.getUnitTeamLeaders();
        this.getUnitAthletes();
        this.getUnitTeams();
    },
    methods: {
        clickQueryBtn() {
            this.tb.pageNum = 1;
            this.fetchRecords();
        },
        getRowKey(row) {
            return row.TeamLeaderId;
        },

        clickEditBth(row) {
            this.dialogVisible = true;
            this.firstLoadSignUpForm = true;
            this.fileList = [];
            this.teamPhotoFiles = [];
            this.getMatchDetail(row);
        },

        hideSignUpFormDialog() {
            this.signUpResultDialogVisible = false;
        },
        handleProSelectionChange(val, index) {
            console.log(val, index);
            // 获取当前组的项目列表
            const currentProjects = this.signUpMatchGroups[index].Projects;
            // 获取之前选中的项目ID列表
            const previousCheckedIds = (this.signUpMatchGroups[index].checkedPros || []).map(p => p.ProjectId);
            // 获取新选中的项目ID列表
            const newCheckedIds = val.map(p => p.ProjectId);

            // 更新选中的项目
            this.signUpMatchGroups[index].checkedPros = val;

            // 找出被取消选中的项目ID
            const uncheckedIds = previousCheckedIds.filter(id => !newCheckedIds.includes(id));

            // 清除被取消项目的运动员
            uncheckedIds.forEach(projectId => {
                const projectIndex = currentProjects.findIndex(p => p.ProjectId === projectId);
                if (projectIndex !== -1) {
                    this.$set(currentProjects[projectIndex], 'athletes', []);
                }
            });
        },

        handleStaffTableSelectionChange(val) {
            console.log(val);
            this.staffTableSelection = val;
        },

        backStep() {
            this.sipnUpStep -= 1;
        },

        buildSignUpGroupsData() {
            const signUpGroups = [];

            this.signUpMatchGroups.forEach(group => {
                // 只处理有选中项目的分组
                if (group.checkedPros && group.checkedPros.length > 0) {
                    const groupData = {
                        GroupId: group.GroupId,
                        Projects: []
                    };

                    // 处理该分组下的所有选中项目
                    group.Projects.forEach(project => {
                        // 只处理有运动员的项目
                        if (project.athletes && project.athletes.length > 0) {
                            const projectData = {
                                ProjectId: project.ProjectId,
                                SignUpType: project.SignUpLimitType, // 0:团队 1:个人
                                Athletes: [],
                                MusicFile: project.File || null      // 如果有音乐文件
                            };

                            // 简化处理项目的运动员数据
                            if (project.SignUpLimitType === 0) {
                                // 团队模式 - 把每个团队的运动员ID拼接成字符串
                                projectData.Athletes = project.athletes.map(team => {
                                    // 确保userIds是字符串
                                    return Array.isArray(team.userIds) ?
                                        team.userIds.join(',') :
                                        team.userIds;
                                });
                            } else {
                                // 个人模式 - 提供每个运动员ID
                                projectData.Athletes = project.athletes.map(athlete =>
                                    athlete.userIds
                                );
                            }

                            groupData.Projects.push(projectData);
                        }
                    });

                    signUpGroups.push(groupData);
                }
            });

            return signUpGroups;
        },

        // 构建随队人员数据
        buildTeamLeadersData() {
            return this.staffTableSelection.map(staff => staff.TeamLeaderId);
        },

        // 构建团队照片数据
        buildTeamPhotoFilesData() {
            // return this.teamPhotoFiles.map(file => ({
            //     FileId: file.FileId,
            //     FileName: file.FileName,
            //     FilePath: file.TeamPhotoFilePath
            // }));
            return this.teamPhotoFiles.map(file => file.FileId);
        },

        // 格式化日期时间，移除ISO格式中的T
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            return dateTimeStr.replace('T', ' ');
        },
        formatBirthday(dateTimeStr) {
            console.log(dateTimeStr);
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            if (dateTimeStr.indexOf('T') > -1) return dateTimeStr.split('T')[0];
            return dateTimeStr.split(' ')[0];
        },
        // 获取扁平化的项目列表（将团队和个人项目展开为单行）
        getFlattenedProjectsList() {
            const flattenedList = [];

            this.signUpMatchGroups.forEach(group => {
                group.Projects.forEach(project => {
                    if (project.athletes && project.athletes.length > 0) {
                        if (project.SignUpLimitType === 0) { // 团队项目
                            project.athletes.forEach(team => {
                                flattenedList.push({
                                    groupName: group.GroupName,
                                    projectName: project.ProjectName,
                                    projectTypeName: project.ProjectTypeName,
                                    genderRuleText: project.GenderRuleText,
                                    athleteName: team.userNames,
                                    // 添加用于合并判断的键
                                    mergeKey: `${group.GroupId}-${project.ProjectId}-${project.ProjectTypeId}-${project.GenderRule}`
                                });
                            });
                        } else { // 个人项目
                            project.athletes.forEach(athlete => {
                                flattenedList.push({
                                    groupName: group.GroupName,
                                    projectName: project.ProjectName,
                                    projectTypeName: project.ProjectTypeName,
                                    genderRuleText: project.GenderRuleText,
                                    athleteName: athlete.userNames,
                                    // 添加用于合并判断的键
                                    mergeKey: `${group.GroupId}-${project.ProjectId}-${project.ProjectTypeId}-${project.GenderRule}`
                                });
                            });
                        }
                    }
                });
            });

            // 按mergeKey排序，确保相同的项目在一起
            flattenedList.sort((a, b) => a.mergeKey.localeCompare(b.mergeKey));
            return flattenedList;
        },

        handleProjectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex > 3) { // 运动员列不合并
                return [1, 1];
            }

            const data = this.getFlattenedProjectsList();

            if (rowIndex === 0) {
                // 第一行的处理
                let rowspan = 1;
                // 向下查找相同值的行数
                for (let i = 1; i < data.length; i++) {
                    if (this.shouldMerge(data[0], data[i], columnIndex)) {
                        rowspan++;
                    } else {
                        break;
                    }
                }
                return [rowspan, 1];
            } else {
                // 其他行的处理
                const prevRow = data[rowIndex - 1];
                const currentRow = data[rowIndex];

                // 如果与上一行相同，则隐藏当前行
                if (this.shouldMerge(prevRow, currentRow, columnIndex)) {
                    return [0, 0];
                }

                // 如果与上一行不同，计算向下合并的行数
                let rowspan = 1;
                for (let i = rowIndex + 1; i < data.length; i++) {
                    if (this.shouldMerge(currentRow, data[i], columnIndex)) {
                        rowspan++;
                    } else {
                        break;
                    }
                }
                return [rowspan, 1];
            }
        },

        shouldMerge(prevRow, currentRow, columnIndex) {
            // 根据列索引判断是否应该合并
            switch (columnIndex) {
                case 0: // 组别
                    return prevRow.groupName === currentRow.groupName;
                case 1: // 项目名称
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName;
                case 2: // 项目类型
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName &&
                        prevRow.projectTypeName === currentRow.projectTypeName;
                case 3: // 性别
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName &&
                        prevRow.projectTypeName === currentRow.projectTypeName &&
                        prevRow.genderRuleText === currentRow.genderRuleText;
                default:
                    return false;
            }
        },

        // 获取所有参赛运动员信息（整合所有项目中的运动员）
        getAllAthletes() {
            // 用于存储唯一的运动员ID
            const uniqueAthleteIds = new Set();

            // 遍历所有选中的项目，收集唯一的运动员ID
            this.signUpMatchGroups.forEach(group => {
                group.Projects.forEach(project => {
                    if (project.athletes && project.athletes.length > 0) {
                        project.athletes.forEach(athlete => {
                            const athleteIds = Array.isArray(athlete.userIds) ?
                                athlete.userIds :
                                athlete.userIds.split(',');

                            athleteIds.forEach(id => {
                                uniqueAthleteIds.add(id);
                            });
                        });
                    }
                });
            });

            const athletes = [];

            // 直接从unitAthleteList中获取运动员信息
            for (const athleteId of uniqueAthleteIds) {
                const athleteOption = this.unitAthleteList.find(a => a.AthleteId === athleteId);
                if (athleteOption) {
                    // 创建运动员对象，使用固定值或者从其他数据源获取更多信息
                    athletes.push({
                        athleteId: athleteId,
                        athleteName: athleteOption.UserName,
                        identityCard: athleteOption.IdentityCard,
                        age: athleteOption.Age,
                        gender: athleteOption.Gender,
                        phone: athleteOption.UserPhone,
                        grade: athleteOption.Grade
                    });
                }
            }

            return athletes;
        },
        handleNextStep() {
            // 步骤0：验证是否选择了项目和运动员
            if (this.sipnUpStep === 0) {
                // 检查是否有选中的项目
                let hasSelectedProjects = false;
                // 检查是否为选中的项目选择了运动员
                let hasSelectedAthletes = false;
                // 检查必报项目是否都已选择
                let missingMustSignUpProjects = [];

                for (const group of this.signUpMatchGroups) {
                    // 检查必报项目
                    group.Projects.forEach(project => {
                        if (project.IsMustSignUp === 1) {
                            const isSelected = group.checkedPros.some(p => p.ProjectId === project.ProjectId);
                            if (!isSelected) {
                                missingMustSignUpProjects.push(`${group.GroupName}-${project.ProjectName}`);
                            }
                        }
                    });

                    if (group.checkedPros && group.checkedPros.length > 0) {
                        hasSelectedProjects = true;

                        // 检查是否为每个选中的项目选择了运动员
                        for (const project of group.Projects) {
                            // 只检查被选中的项目
                            if (group.checkedPros.find(p => p.ProjectId === project.ProjectId)) {
                                if (project.athletes && project.athletes.length > 0) {
                                    hasSelectedAthletes = true;
                                    break;
                                }
                            }
                        }
                    }
                }

                // 检查是否有未选择的必报项目
                if (missingMustSignUpProjects.length > 0) {
                    this.$message.warning(`以下必报项目尚未选择：${missingMustSignUpProjects.join('、')}`);
                    return;
                }

                if (!hasSelectedProjects) {
                    this.$message.warning('请至少选择一个参赛项目');
                    return;
                }

                if (!hasSelectedAthletes) {
                    this.$message.warning('请为选中的项目添加参赛运动员');
                    return;
                }
            }

            // 步骤1：验证是否选择了随队人员
            else if (this.sipnUpStep === 1) {
                if (this.staffTableSelection.length === 0) {
                    this.$message.warning('请至少选择一名随队人员');
                    return;
                }
            }

            // 通过验证，进入下一步
            this.sipnUpStep += 1;

            if (this.sipnUpStep == 1 && this.firstLoadSignUpForm) {
                console.log("this.staffTableSelection:", this.staffTableSelection);
                console.log("处理随队人员表格选中");
                this.firstLoadSignUpForm = false;
                let selectedRows = [];
                for (let i = 0; i < this.staffTableSelection.length; i++) {
                    selectedRows.push(this.staffTableSelection[i].TeamLeaderId);
                }

                setTimeout(() => {
                     this.$nextTick(() => {
                        
                         //this.$refs.multipleTable2.toggleRowSelection(this.staffTableSelection[1]);
                    for (let i = 0; i < selectedRows.length; i++) {
                       
                        let row = this.unitStaffList.find(item => item.TeamLeaderId === selectedRows[i]);
                        console.log("row:", row);
                        this.$refs.multipleTable2.toggleRowSelection(row,true);
                       
                    }
                     });
                }, 500);
            }
        },
        openAthleteDialog(project, index) {
            this.currentProject = project;
            this.currentGroupIndex = index;
            this.currentProjectIndex = this.signUpMatchGroups[index].Projects.indexOf(project);
            this.athleteActiveTab = 'athletes';
            this.tempSelectedAthletes = []; // 清空临时选择的运动员

            // 如果已有选择的运动员，初始化数据
            if (project.athletes && project.athletes.length > 0) {
                if (project.SignUpLimitType === 0) {
                    // 团队模式
                    this.selectedTeams = project.athletes.map(team => ({
                        userIds: typeof team.userIds === 'string' ? team.userIds.split(',') : team.userIds,
                        userNames: team.userNames
                    }));
                } else {
                    // 个人模式
                    this.selectedAthleteIds = project.athletes.map(athlete =>
                        typeof athlete.userIds === 'string' ? athlete.userIds : athlete.userIds.toString()
                    );
                }
            } else {
                // 没有已选运动员时的初始化
                if (project.SignUpLimitType === 0) {
                    this.selectedTeams = [];  // 改为空数组，不预设团队
                } else {
                    this.selectedAthleteIds = [];
                }
            }

            this.athleteDialogVisible = true;
        },
        handleTeamAthleteChange(event, teamIndex) {
            this.selectedTeams[teamIndex].userIds = event;
        },
        addNewTeam() {
            this.selectedTeams.push({ userIds: [] });
        },
        removeTeam(index) {
            this.selectedTeams.splice(index, 1);
        },
        handleAthleteChange(event) {
            this.selectedAthleteIds = event;
        },
        handleTeamSelectionChange(event) {
            this.selectedTeams = event.map(team => ({
                userIds: team.userIds,
                teamId: team.TeamId,
                teamName: team.TeamName
            }));
        },
        confirmAthleteSelection() {
            if (this.currentProject && this.currentGroupIndex !== null && this.currentProjectIndex !== null) {
                let athletes = [];

                if (this.currentProject.SignUpLimitType === 0) {
                    // 团队模式
                    // 检查是否超过限制
                    if (this.selectedTeams.length > this.currentProject.SignUpLimitNum) {
                        this.$message.warning(`最多只能选择${this.currentProject.SignUpLimitNum}个团队`);
                        return;
                    }
                    athletes = this.selectedTeams.map(team => ({
                        userIds: Array.isArray(team.userIds) ? team.userIds.join(',') : team.userIds,
                        userNames: team.userNames,
                        teamId: team.teamId,
                        teamName: team.teamName
                    }));
                } else {
                    // 个人模式
                    // 检查是否超过限制
                    if (this.selectedAthleteIds.length > this.currentProject.SignUpLimitNum) {
                        this.$message.warning(`该项目最多只能选择${this.currentProject.SignUpLimitNum}名运动员`);
                        return;
                    }
                    athletes = this.selectedAthleteIds.map(id => ({
                        userIds: id,
                        userNames: this.unitAthleteList.find(a => a.AthleteId === id).UserName || ''
                    }));
                }

                // 更新项目的运动员数据
                this.$set(
                    this.signUpMatchGroups[this.currentGroupIndex].Projects[this.currentProjectIndex],
                    'athletes',
                    athletes
                );
            }

            console.log(this.signUpMatchGroups, this.signUpMatchGroups[this.currentGroupIndex].Projects[this.currentProjectIndex])

            this.athleteDialogVisible = false;
        },
        // 创建新团队
        createTeam() {
            if (!this.tempSelectedAthletes.length) {
                return;
            }

            // 检查团队数量是否已达到限制
            if (this.selectedTeams.length >= this.currentProject.SignUpLimitNum) {
                this.$message.warning(`该项目最多只能添加${this.currentProject.SignUpLimitNum}个团队`);
                return;
            }

            // 获取选中运动员的名字
            const names = this.tempSelectedAthletes.map(id =>
                this.unitAthleteList.find(a => a.AthleteId === id).UserName
            ).filter(Boolean);

            // 创建新团队对象
            const newTeam = {
                userIds: this.tempSelectedAthletes,  // 保持为数组
                userNames: names.join(',')
            };

            // 添加到已选择的团队列表
            this.selectedTeams.push(newTeam);

            // 清空临时选择
            this.tempSelectedAthletes = [];
        },

        // 添加已有团队
        addExistingTeam(team) {
            // 检查团队数量是否已达到限制
            if (this.selectedTeams.length >= this.currentProject.SignUpLimitNum) {
                this.$message.warning(`该项目最多只能添加${this.currentProject.SignUpLimitNum}个团队`);
                return;
            }

            const newTeam = {
                userIds: team.AthleteIds,
                userNames: team.AthleteNames,
                teamId: team.TeamId,
                teamName: team.TeamName
            };

            // 检查是否已经添加过这个团队
            const exists = this.selectedTeams.some(t => t.teamId === team.TeamId);
            if (!exists) {
                this.selectedTeams.push(newTeam);
            } else {
                this.$message.warning('该团队已添加');
            }
        },
        removeAthlete(groupIndex, projectIndex, athleteIndex) {
            console.log(1234, groupIndex, projectIndex, athleteIndex, this.signUpMatchGroups);
            const project = this.signUpMatchGroups[groupIndex].Projects[projectIndex];
            if (project.athletes) {
                project.athletes.splice(athleteIndex, 1);
            }
        },
        // 确认报名
        confirmSignUp(type = '提交') {
            // 构建报名数据对象
            const signUpData = {
                SignUpFormId: this.signUpFormId,
                MatchId: this.matchInfo.MatchId,                    // 赛事ID
                UnitId: this.unitInfo.UnitId,                      // 单位ID
                GroupId: this.groupRadioValue,                 // 分组ID
                SubmitType: type,
                SignUpGroups: this.buildSignUpGroupsData(),        // 报名分组和项目数据
                TeamLeaderIds: this.buildTeamLeadersData(),          // 随队人员数据
                TeamPhotoFileIds: this.teamPhotoFiles == null ? [] : this.buildTeamPhotoFilesData()    // 团队照片数据
            };

            contestantServices.submitMatchSignUpForm(signUpData).then(res => {
                if (res.code === 0) {
                    if(type == '提交'){
                        this.$message.success('报名成功');
                    }else{
                        this.$message.success('存草稿成功');
                    }
                    this.dialogVisible = false;
                    this.fetchRecords();
                }
            });
        },

        getUnitMatchSignUpForm(formId) {

            contestantServices.getUnitMatchSignUpForm({ formId: formId })
                .then(resData => {
                    console.log(resData);
                    if (resData.code == 0 && resData.data) {
                        this.signData = resData.data;
                        console.log(this.signData);
                        console.log(this.signUpMatchGroups[0]);
                        let pros = [];
                        this.signUpFormId = formId;



                        //先将报名表数据整合{ projectId:'',athletes:[{userIds:'',userNames:''}}]}
                        let signUpUserData = [];
                        this.signData.Groups[0].Projects.forEach(project => {
                            //查询这个项目在signUpUserData的下标
                            let index = signUpUserData.findIndex(item => item.projectId == project.ProjectId);
                            if (index == -1) {
                                signUpUserData.push({
                                    projectId: project.ProjectId,
                                    athletes: []
                                })
                                signUpUserData[signUpUserData.length - 1].athletes.push({
                                    userIds: project.AthleteIds,
                                    userNames: project.AthleteNames
                                });
                            } else {
                                signUpUserData[index].athletes.push({
                                    userIds: project.AthleteIds,
                                    userNames: project.AthleteNames
                                });
                            }
                        });
                        //将报名表数据赋值到signUpMatchGroups[0]
                        console.log(signUpUserData);
                        for (let i = 0; i < signUpUserData.length; i++) {
                            let project = signUpUserData[i];
                            for (let j = 0; j < this.signUpMatchGroups[0].Projects.length; j++) {
                                if (this.signUpMatchGroups[0].Projects[j].ProjectId == project.projectId) {
                                    console.log('赋值');
                                    this.$set(this.signUpMatchGroups[0].Projects[j], 'athletes', project.athletes);
                                }
                            }
                            let pro = this.signUpMatchGroups[0].Projects.find(p => p.ProjectId == project.projectId);
                            pros.push(pro);
                        }
                        this.staffTableSelection = [];
                        for (let i = 0; i < this.signData.UnitTeamLeaders.length; i++) {
                            let staff = this.unitStaffList.find(a => a.TeamLeaderId == this.signData.UnitTeamLeaders[i].TeamLeaderId);
                            if (staff) {
                                console.log("this.staffTableSelection.push");
                                this.staffTableSelection.push(staff);
                            }
                        }

                        // this.handleProSelectionChange(pros, 0);
                        for (let i = 0; i < pros.length; i++) {
                            this.$nextTick(() => {
                                this.$refs.multipleTable[0].toggleRowSelection(pros[i]);
                            });
                        }

                        if (this.signData.TeamPhotoFiles) {
                            this.signData.TeamPhotoFiles.forEach(fileItem => {
                                let uploadFile = fileItem;
                                this.teamPhotoFiles.push(uploadFile.FileId);
                                //this.uploadReceiptFiles.push(uploadFile);
                                this.fileList.push({
                                    name: uploadFile.FileName,
                                    url: this.fileRootPath + uploadFile.SaveFolder + '/' + uploadFile.FileId + uploadFile.FileSuffix
                                });
                            });

                        }

                    }
                })
                .finally(() => { });
        },
        getMatchDetail(row) {
            console.log(row);
            contestantServices.getMatchDetail({ matchId: row.MatchId }).then(resData => {
                this.allLoading = false;
                if (resData.code == 0) {
                    this.matchInfo = resData.data;
                    this.groupRadioValue = row.GroupId;
                    if (this.matchInfo && this.matchInfo.MatchGroups && this.matchInfo.MatchGroups.length > 0) {
                        this.matchProjects = this.matchInfo.MatchGroups[0].Projects;
                        if (this.matchProjects && this.matchProjects.length > 1) {
                            this.matchProjects = this.matchProjects.sort((a, b) => a.GenderRule - b.GenderRule)
                        }
                    }

                    // this.handleClickSignUp(row.GroupId);

                    this.sipnUpStep = 0;
                    let group = this.matchInfo.MatchGroups.find(a => a.GroupId == row.GroupId);
                    this.signUpMatchGroups = utilsCommon.copyObj([{ ...group, checkedPros: [] }]);
                    this.signUpTabsActiveName = group.GroupId;

                    this.getUnitMatchSignUpForm(row.SignUpFormId);

                }
            })
        },
        getUnitTeamLeaders() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {}
            }
            this.unitStaffList = [];
            contestantServices.selectUnitTeamLeaders(data).then(res => {
                if (res.code == 0) {
                    this.unitStaffList = res.data.Data;
                }
            })
        },
        getUnitAthletes() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {}
            }
            this.unitAthleteList = [];
            contestantServices.selectUnitAthletes(data).then(res => {
                if (res.code == 0 && res.data.Data) {
                    this.unitAthleteList = res.data.Data;
                }
            })
        },
        getUnitTeams() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {
                }
            }
            this.unitTeamList = [];
            contestantServices.selectUnitTeams(data).then(resDate => {
                if (resDate.code == 0) {
                    this.unitTeamList = resDate.data.Data;
                }
            })
        },
        // 获取报名记录数据
        async fetchRecords() {

            this.loading = true;

            const param = {
                PageIndex: this.tb.pageNum,
                PageSize: this.tb.pageSize,
                Where: {
                    MatchName: this.queryParams.matchName,
                    SignUpStatus: this.queryParams.signUpStatus == -1 ? '' : this.queryParams.signUpStatus
                }
            };

            try {
                this.tb.data = [];
                const res = await contestantServices.selectSignUpForms(param);
                if (res.code == 0) {
                    this.tb.data = res.data.Data;
                    this.tb.total = res.data.TotalRow;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        // 处理每页显示数量变化
        handleSizeChange(size) {
            this.tb.pageSize = size;
            this.fetchRecords();
        },
        // 处理页码变化
        handleCurrentChange(page) {
            this.tb.pageNum = page;
            this.fetchRecords();
        },

        // 获取状态对应的文本
        getStatusText(status) {
            const option = this.statusOptions.find(item => item.value === status);
            return option ? option.label : '未知状态';
        },
        // 获取状态对应的类型
        getStatusType(status) {
            const typeMap = {
                0: 'primary',  // 审核中 - 蓝色
                2: 'warning',  // 已通过 - 绿色
                1: 'success',  // 不通过 - 黄色
            };
            return typeMap[status] || 'info';
        },
        formatDate(date) {
            return utilsCommon.formatDate(date);
        },
        // 查看详情
        viewDetails(record) {

            // this.$router.push('/sign-up-form-print/' + record.SignUpFormId);

            let newWindowWidth = window.screen.availWidth * 0.8;
            let newWindowHeight = window.screen.availHeight * 0.9;
            //跳转到打印预览页面
            window.open(
                `${window.location.origin}/#/sign-up-form-print/${record.SignUpFormId}`,
                "",
                `location=no,height=${newWindowHeight},width=${newWindowWidth}`
            );

        },
        viewScores(row) {
            contestantServices.getUnitMatchScore({ signUpFormId: row.SignUpFormId })
                .then(resData => {
                    console.log(resData);
                    if (resData.code == 0) {
                        this.score = resData.data;
                        this.showScoreVisible = true;
                    }
                })
                .finally(() => { });
        },
        showUploadReceiptDialog(row) {
            this.uploadReceiptFormId = row.SignUpFormId;
            this.fileList = [];
            this.uploadReceiptFileIds = [];
            if (row.ReceiptFileIds) {
                this.uploadReceiptFileIds = row.ReceiptFileIds.split(',');
                row.ReceiptFilePaths.forEach(p => {
                    this.fileList.push({
                        name: '',
                        url: this.fileRootPath + p
                    });
                })

            }
            console.log(this.uploadReceiptFileIds)

            this.uploadReceiptDialogVisible = true;

        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.imageDialogVisible = true;
        },
        handleRemove(file) {
            // 从 fileList 中找到要删除的文件的索引
            const fileIndex = this.fileList.findIndex(item => item.url === file.url);
            if (fileIndex > -1) {
                // 从 fileList 中移除该文件
                this.fileList.splice(fileIndex, 1);
                this.uploadReceiptFileIds.splice(fileIndex, 1);
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传 5 张图片`);
        },

        uploadFile(options, fileType) {
            const file = options.file;
            const formData = new FormData();
            formData.append('files', file);
            formData.append('desc', 'sign-up-files');
            formData.append('type', 'sign-up-files');
            console.log(this.uploadReceiptFileIds)
            this.submitLoading = true;

            systemService.uploadFiles(formData).then(res => {
                if (res.code == 0) {


                    if (fileType == 'teamPhoto') {
                        res.data.forEach(fileItem => {
                            let uploadFile = fileItem;
                            uploadFile['TeamPhotoFilePath'] = uploadFile.SaveFolder + '/' + uploadFile.FileId + uploadFile.FileSuffix;
                            this.teamPhotoFiles.push(uploadFile);
                            this.fileList.push({
                                name: uploadFile.FileName,
                                url: this.fileRootPath + uploadFile.TeamPhotoFilePath
                            });
                        });
                    } else {
                        res.data.forEach(fileItem => {
                            let uploadFile = fileItem;
                            this.uploadReceiptFileIds.push(uploadFile.FileId);
                            //this.uploadReceiptFiles.push(uploadFile);
                            this.fileList.push({
                                name: uploadFile.FileName,
                                url: this.fileRootPath + uploadFile.SaveFolder + '/' + uploadFile.FileId + uploadFile.FileSuffix
                            });
                        });
                    }
                    this.$message.success('上传成功');
                }
            }).finally(() => {
                this.submitLoading = false;
            });
        },

        setMatchSignUpFormReceiptFileIds() {
            let data = {
                formId: this.uploadReceiptFormId,
                fileIds: this.uploadReceiptFileIds.join(',')
            }
            contestantServices.setMatchSignUpFormReceiptFileIds(data).then(resData => {
                if (resData.code == 0) {
                    this.$message.success(resData.data);
                    this.fetchRecords();
                    this.uploadReceiptDialogVisible = false;
                }
            })
            console.log(data)
        },

        printForm() {
            this.print = true;
            setTimeout(() => {
                window.print();
            }, 1500);
            // this.print = false;
        }
    }
};
</script>

<style scoped>
.competition-record {
    width: 1400px;
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    background: #fff;
}

.search-container {
    border-radius: 4px;
}

.table-container {
    border-radius: 4px;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
}

/* 调整表格样式 */
:deep(.el-table) {
    /* 加深表格边框颜色 */
    --el-table-border-color: #DCDFE6;
    border-color: #DCDFE6;
}

:deep(.el-table td.el-table__cell),
:deep(.el-table th.el-table__cell) {
    /* 加深单元格边框颜色 */
    border-color: #DCDFE6;
}

:deep(.el-table__cell) {
    /* 加深文字颜色 */
    color: #303133;
}

:deep(.el-table__header-wrapper) {

    /* 加深表头背景色和文字颜色 */
    th.el-table__cell {
        background-color: #F5F7FA;
        color: #303133;
        font-weight: 600;
    }
}

/* 可选：鼠标悬停时的行背景色 */
:deep(.el-table__body tr:hover > td.el-table__cell) {
    background-color: #F5F7FA;
}


.sign-up-confirmation {
    text-align: left;
    padding: 20px;
}

.info-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    table-layout: fixed;
    /* 添加固定表格布局 */
}

.info-table td {
    padding: 8px;
    border: 1px solid #DCDFE6;
    line-height: 24px;
}

.info-table .label {
    background-color: #F5F7FA;
    font-weight: bold;
    width: 120px;
}

/* 确保第三列标签的宽度与第一列一致 */
.info-table td:nth-child(3).label {
    width: 120px;
}

.projects-list,
.staff-list {
    margin-top: 20px;
}

.projects-list h4,
.staff-list h4 {
    margin-bottom: 10px;
    color: #303133;
    font-weight: bold;
}
</style>